<script setup lang="ts">
import { useField } from "vee-validate";
import { CheckboxIndicator, CheckboxRoot } from "reka-ui";
import { Check } from "@/components/icons";

const props = defineProps<{
  name: string;
}>();

const { value } = useField<boolean>(props.name);
</script>

<template>
  <div class="flex items-center">
    <CheckboxRoot
      class="w-5 h-5 border border-border-primary rounded-md bg-background-secondary data-[state=checked]:border-none"
      v-model="value"
      :id="name"
      :name="name"
    >
      <CheckboxIndicator
        class="flex-center h-full w-full rounded-md bg-background-brand text-text-white"
      >
        <Check weight="bold" :size="16" />
      </CheckboxIndicator>
    </CheckboxRoot>
    <label :for="name" class="ml-2">
      <slot />
    </label>
  </div>
</template>
